import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

// ✅ Common Layout Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import Seo from "./components/Seo";
import { LoaderProvider, useLoader } from './components/LoaderContext';
import PagePreloader from './components/PagePreloader';
import './responsive.css';
import ScrollToTop from "./components/layout/ScrollToTop";
// ✅ Page Imports
import Home from "./pages/Home";
import InnovativeSolutionTechnologies from "./components/groupcompanies/InnovativeSolutionTechnologies";
import DigitalIndiaLeader from "./components/groupcompanies/DigitalIndiaLeader";
import Iidts from "./components/groupcompanies/Iidts";
import ThirstyHunter from "./components/groupcompanies/ThirstyHunter";
import BookYouOnline from "./components/groupcompanies/BookYouOnline";

import BusinessTechnology from "./components/solutionservices/BusinessTechnology";
import DigitalMarketingSolution from "./components/solutionservices/DigitalMarketingSolution";
import DigitalPaymentsSolution from "./components/solutionservices/DigitalPaymentsSolution";
import BusinessProcessManagement from "./components/solutionservices/BusinessProcessManagement";
import CloudInfrastructure from "./components/solutionservices/CloudInfrastructure";
import TechDigitalConsulting from "./components/solutionservices/TechDigitalConsulting";
import AiAnalytics from "./components/solutionservices/AiAnalytics";

import Healthcare from "./components/industries/Healthcare";
import TravelHospitality from "./components/industries/TravelHospitality";
import Publishing from "./components/industries/Publishing";
import EcommerceRetail from "./components/industries/EcommerceRetail";
import BankingFintech from "./components/industries/BankingFintech";
import ManufacturingTech from "./components/industries/ManufacturingTech";
import GovernmentPublicSector from "./components/industries/GovernmentPublicSector";

import Clients from "./components/clients/Clients";
import Contact from "./components/contact/Contact";
import About from "./components/About";
import Awards from "./components/Awards";
import Careers from "./components/Careers";
import LifeAtIsols from "./components/LifeAtIsols";
import Csr from "./components/Csr";
import Media from "./components/Media";
import InvestorRelations from "./components/InvestorRelations";
import ClientsTestimonial from "./components/ClientsTestimonial";

import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RefundPolicy from "./components/RefundPolicy";
import DMCAPolicy from "./components/DMCAPolicy";
import Sitemap from "./components/Sitemap";

import SearchEngineOptimization from "./components/SearchEngineOptimization";
import InfluencerMarketing from "./components/importantlinks/InfluencerMarketing";
import InfluencerNetwork from "./components/importantlinks/InfluencerNetwork";
import SocialMediaMarketing from "./components/importantlinks/SocialMediaMarketing";
import ORM from "./components/importantlinks/ORM";
import PayPerClick from "./components/importantlinks/PayPerClick";


// import { useLocation } from "react-router-dom";
// import Seo from "./components/Seo";



const AppContent = () => {
  const { pathname } = useLocation();
  const loader = useLoader();

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.debug("Route change ->", pathname);

    // Show loader on route change; hide after a short delay to avoid flicker.
    if (loader && loader.show && loader.hide) {
      loader.show();
      const t = setTimeout(() => loader.hide(), 350);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [pathname, loader]);

  return (
    <>
      {/* ✅ SEO Meta Tags */}
      <Seo path={pathname} />
      
      {/* ✅ Common Header on every page */}
      <ScrollToTop />

      <Header />

      {/* ✅ Page Routes */}
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/innovative-solution-technologies" element={<InnovativeSolutionTechnologies />} />
          <Route path="/digital-india-leader" element={<DigitalIndiaLeader />} />
          <Route path="/iidts" element={<Iidts />} />
          <Route path="/thirsty-hunter" element={<ThirstyHunter />} />
          <Route path="/book-you-online" element={<BookYouOnline />} />

          <Route path="/business-technology-solutions" element={<BusinessTechnology />} />
          <Route path="/digital-marketing-solutions" element={<DigitalMarketingSolution />} />
          <Route path="/digital-payment-solutions" element={<DigitalPaymentsSolution />} />
          <Route path="/business-process-management" element={<BusinessProcessManagement />} />
          <Route path="/cloud-infra-solutions" element={<CloudInfrastructure />} />
          <Route path="/technology-digital-consulting" element={<TechDigitalConsulting />} />
          <Route path="/ai-analytics" element={<AiAnalytics />} />

          <Route path="/healthcare-medical-solutions" element={<Healthcare />} />
          <Route path="/travel-hospitality-solutions" element={<TravelHospitality />} />
          <Route path="/publishing" element={<Publishing />} />
          <Route path="/ecommerce-retail-solutions" element={<EcommerceRetail />} />
          <Route path="/banking-finance-solutions" element={<BankingFintech />} />
          <Route path="/manufacturing-industry-solutions" element={<ManufacturingTech />} />
          <Route path="/government-publicsector-solutions" element={<GovernmentPublicSector />} />

          <Route path="/clients" element={<Clients />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-isolsgroup" element={<About />} />
          <Route path="/award-certifications" element={<Awards />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/vibrant-culture" element={<LifeAtIsols />} />
          <Route path="/csr" element={<Csr />} />
          <Route path="/media-releases" element={<Media />} />
          <Route path="/investor-relations" element={<InvestorRelations />} />
          <Route path="/testimonial" element={<ClientsTestimonial />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/dmca-policy" element={<DMCAPolicy />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/search-engine-optimization" element={<SearchEngineOptimization />} />
          <Route path="/social-media-marketing" element={<SocialMediaMarketing />} />
          <Route path="/influencer-marketing" element={<InfluencerMarketing />} />
          <Route path="/influencer-network" element={<InfluencerNetwork />} />
          <Route path="/online-reputation-management" element={<ORM />} />
          <Route path="/pay-per-click" element={<PayPerClick />} />
        </Routes>

        {/* ✅ Common Footer on every page */}
        <Footer />
      </>
    );
};

const App = () => {
  return (
    <>
      {/* ✅ Global CSS */}
      <link rel="stylesheet" href={"./css/main.css"} />
      <Router>
        {/* <LoaderProvider>
          <PagePreloader /> */}
          <AppContent />
        {/* </LoaderProvider> */}
      </Router>
    </>
  );
};

export default App;
